module.exports = __webpack_public_path__ + "static/media/null_money.52d6f9b3.png";